import React, { ReactElement } from 'react'
import { useAuthenticator } from '@aws-amplify/ui-react'
import Authentication from './Authenticator'
import ProductList from './components/Product-list/Product-list'

const Home = (): ReactElement => {
  const { route } = useAuthenticator(context => [context.route])

  return route === 'authenticated' ? <ProductList /> : <Authentication />
}

export default Home
